import { DefaultOptionType } from 'rc-select/lib/Select';
import { createStore } from '../../../common/Store';
import { AlgorithmSourceFormDataType } from '../sources/schema/types';
import type { AlgorithmMappingQueryDtoType } from '../mappings/schema/types';

export interface AlgorithmJoinsFormStoreData {
  sources: AlgorithmSourceFormDataType[];
  mappings: AlgorithmMappingQueryDtoType[];
  algorithmSourcesByIds: Map<number, AlgorithmSourceFormDataType>;
  joinTypeOptions: DefaultOptionType[];
  showAutoJoin: boolean;
  isDbSources: boolean;
}

export const AlgorithmJoinsFormStore =
  createStore<AlgorithmJoinsFormStoreData>();
